import { CommonModule } from '@angular/common';
import { AlertasService } from '@core/services/alertas.service';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { IconComponent } from '@shared/icon/icon.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-alerta',
  imports: [CommonModule, IconComponent, TranslateModule],
  templateUrl: './alerta.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './alerta.component.css',
})
export class AlertaComponent {
  constructor(public alertaService: AlertasService) {}
}
